import getHost from 'utils/getHost'
import prependSlashMaybe from 'utils/prependSlashMaybe'

const account = '/account'

const redirectToAccount = () => {
  window.location.href = `${getHost()}${prependSlashMaybe(encodeURI(account))}`
}

export default redirectToAccount



// WEBPACK FOOTER //
// ./src/modules/App/actions/redirectToAccount.js